import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class reporteRotacionService {
    /******* QUERIES ******/

    async general(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-rotacion/general?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async resumen(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-rotacion/resumen?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelGeneral(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-rotacion/excel-general?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };   


    async excelResumen(filter) {
        const response = await axios
            .get(`${ERP}logistica/reporte-rotacion/excel-resumen?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

}

export default new reporteRotacionService();